import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Capacitor } from '@capacitor/core';
import { LoadingController, ViewWillEnter } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import {
  TokenAuthMode,
  TokenAuthOptions,
  UsfTokenService,
} from '@panamax/app-state';
import { PATHS } from '../../shared/constants/paths';
import { CommonUtils } from '../login-punch-common/common-utils';
import { OrderLoginPunchthruService } from './services/order-login-punchthru.service';
import { LoadingSpinnerService } from '@shared/services/loading-spinner/loading-spinner.service';

@Component({
  selector: 'app-login-punchthru',
  templateUrl: './login-punchthru.page.html',
  styleUrls: ['./login-punchthru.page.scss'],
})
export class LoginPunchthruPage implements ViewWillEnter {
  loadingElement: HTMLIonLoadingElement;
  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private loadingController: LoadingController,
    private tokenService: UsfTokenService,
    private translateSerivce: TranslateService,
    private orderLoginPunchthruService: OrderLoginPunchthruService,
    private loadingSpinnerService: LoadingSpinnerService,
  ) {}

  async ionViewWillEnter() {
    this.presentLoading();

    let punchthruToken;
    let authMode;
    if (this.activatedRoute.snapshot.queryParams['ptID']) {
      punchthruToken = this.activatedRoute.snapshot.queryParams['ptID'];
      authMode = TokenAuthMode.Punchthru;
      console.log('[LoginPunchthruPage] Authorizing punchthru session');
    } else if (this.activatedRoute.snapshot.queryParams['nvptID']) {
      punchthruToken = this.activatedRoute.snapshot.queryParams['nvptID'];
      authMode = TokenAuthMode.NvPunchthru;
      console.log('[LoginPunchthruPage] Authorizing nv-punchthru session');
    }

    const isValidGuid = CommonUtils.isValidGuid(punchthruToken);

    if (!isValidGuid) {
      console.error('[LoginpunchthruPage] ERROR: Invalid punchthru token');
      this.router.navigate([PATHS.LOGIN_ERROR]);
      return;
    }

    const tokenAuthOptions: TokenAuthOptions = {
      platform: Capacitor.isNativePlatform() ? 'MOBILE' : 'DESKTOP',
      punchthruToken,
      kmsi: false,
    };

    await this.tokenService
      .authorize(authMode, tokenAuthOptions)
      .then(_ => {
        if (this.activatedRoute.snapshot.queryParams['ptID']) {
          this.orderLoginPunchthruService.loadVptOrder();
        }
        if (this.activatedRoute.snapshot.queryParams['nvptID']) {
          this.orderLoginPunchthruService.loadNvptOrder();
        }
      })
      .catch(error => {
        this.handlePunchthruError(error);
      });
    this.dismissLoading();
    await this.loadingSpinnerService.createSpinnerModal();
  }

  navigateToHome() {
    this.router.navigate([PATHS.HOME]);
  }

  navigateToLoginError() {
    this.router.navigate([PATHS.LOGIN_ERROR]);
  }

  async handlePunchthruError(error: any): Promise<void> {
    console.error(
      '[LoginpunchthruTokenPage] Error during punchthruToken login: ',
      error,
    );
    await this.tokenService.logout();
    this.navigateToLoginError();
    return;
  }

  async presentLoading() {
    this.loadingElement = await this.loadingController.create({
      //Not translating this as translation API call has not always completed in time, leading to "i18n..." to appear in modal text.
      message: 'Logging in and fetching data...',
      spinner: 'circles',
      duration: 3000,
    });
    await this.loadingElement.present();
  }

  async dismissLoading() {
    this.loadingElement = await this.loadingController.getTop();
    if (this.loadingElement) {
      await this.loadingElement.dismiss();
    }
  }
}
